import { render, staticRenderFns } from "./component.vue?vue&type=template&id=60140e62&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60140e62')) {
      api.createRecord('60140e62', component.options)
    } else {
      api.reload('60140e62', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=60140e62&", function () {
      api.rerender('60140e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/dialog/src/component.vue"
export default component.exports